<template>
	<FormGroup :label="label" :helpText="helpText">
		<div class="flex items-center gap-2">
			<div class="relative flex-shrink-0 inline-block w-12 h-6">
				<input
					:id="`form-switch-${id}`"
					:name="name"
					type="checkbox"
					class="sr-only peer"
					:disabled="disabled"
					:checked="value"
					:aria-label="ariaLabel"
					@input="$emit('input', $event.target.checked)"
				/>
				<label
					:for="`form-switch-${id}`"
					class="absolute inset-0 w-12 h-6 transition-colors duration-200 ease-in-out rounded-full cursor-pointer bg-neutral-300 peer-checked:bg-neutral-900"
					:class="{ 'opacity-50 cursor-not-allowed': disabled }"
				></label>
				<div
					class="absolute w-4 h-4 transition-transform duration-200 ease-in-out bg-white rounded-full pointer-events-none left-1 top-1 peer-checked:translate-x-6"
				></div>
			</div>
			<span v-if="states.length" class="text-sm">{{
				states[value ? 0 : 1] || ''
			}}</span>
		</div>
	</FormGroup>
</template>
<script>
import FormGroup from '~/components/ui/form/FormGroup'

export default {
	components: {
		FormGroup
	},
	props: {
		value: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: null
		},
		name: {
			type: String,
			default: null
		},
		helpText: {
			type: String,
			default: null
		},
		// For toggles whose name is rendered outside this component (e.g. a row
		// label), since the input itself is sr-only and has no visible text.
		ariaLabel: {
			type: String,
			default: null
		},
		states: {
			type: Array,
			default: () => []
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		id() {
			return this.name || this.label || parseInt(Math.random() * 1000)
		}
	}
}
</script>
